export default __webpack_public_path__ + "static/media/blocks.eddf822b.svg";